import * as React from "react"
import type { SVGProps } from "react"
const SvgDashboardFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M10.46 15.5q.62.63 1.58.59.95-.05 1.37-.69l4.23-6.33q.22-.34-.06-.63-.29-.3-.64-.06l-6.33 4.22q-.65.45-.71 1.36-.07.91.56 1.54M5.1 20q-.54 0-1.01-.24-.45-.24-.74-.71a11 11 0 0 1-1-2.44 9.7 9.7 0 0 1 .44-6.51A10 10 0 0 1 8.1 4.79 10 10 0 0 1 12 4q2.05 0 3.86.78a10 10 0 0 1 5.3 5.23q.8 1.8.83 3.84a10 10 0 0 1-1.35 5.2q-.28.48-.74.71-.46.24-1.02.24z" />
  </svg>
)
export default SvgDashboardFilled
